﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListBenutzer extends GuiListGeneric {

    constructor() {
        super("Benutzer");

    }

}

